import { Phone, Handshake, Cake, Heart, Pause, ClipboardText } from "@phosphor-icons/react";

export const TYPES = {
  relance_client: { label: "Relance client", icon: Phone, cls: "bg-sky-100 text-sky-800" },
  relance_apporteur: { label: "Relance apporteur", icon: Handshake, cls: "bg-indigo-100 text-indigo-800" },
  anniversaire: { label: "Anniversaire", icon: Cake, cls: "bg-pink-100 text-pink-800" },
  post_signature: { label: "Suivi post-signature", icon: Heart, cls: "bg-emerald-100 text-emerald-800" },
  standby: { label: "Stand-by", icon: Pause, cls: "bg-amber-100 text-amber-800" },
  bos_hebdo: { label: "BOS / Hebdo", icon: ClipboardText, cls: "bg-slate-200 text-slate-800" },
};

export const fmtDate = (iso) => (iso ? new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "2-digit" }) : "");
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris" }) : "");
export const addDays = (isoToday, n) => { const d = new Date(isoToday + "T00:00:00Z"); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

export const TypePill = ({ type }) => {
  const t = TYPES[type] || TYPES.bos_hebdo; const I = t.icon;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${t.cls}`} data-testid={`task-type-${type}`}><I size={12} weight="fill" />{t.label}</span>;
};
